function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 16L7 14.5M7 14.5L1 17.5V4.5L7 1.5M7 14.5V1.5M7 1.5L13 4.5M13 4.5L19 1.5V9M13 4.5V10M17 15.5V15.51M19.121 17.621C19.5406 17.2015 19.8265 16.6669 19.9423 16.085C20.0581 15.503 19.9988 14.8997 19.7717 14.3515C19.5447 13.8033 19.1602 13.3347 18.6668 13.005C18.1734 12.6753 17.5934 12.4994 17 12.4994C16.4066 12.4994 15.8266 12.6753 15.3332 13.005C14.8398 13.3347 14.4553 13.8033 14.2283 14.3515C14.0012 14.8997 13.9419 15.503 14.0577 16.085C14.1735 16.6669 14.4594 17.2015 14.879 17.621C15.297 18.0397 16.004 18.666 17 19.5C18.0513 18.61 18.7583 17.9837 19.121 17.621Z",
  stroke: "#272723",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgIconMap = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-map.b5341234.svg";
export { ForwardRef as ReactComponent };